var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 673.8 340.2",
    style: {
      enableBackground: "new 0 0 673.8 340.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#5358A7;}\r\n\t.st2{fill:#00A5CD;}\r\n\t.st3{fill:#2A9A7C;}\r\n\t.st4{fill:#EF464B;}\r\n\t.st5{fill:#D2A7CD;}\r\n\t.st6{fill:#AB4399;}\r\n\t.st7{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M211.3,94.5h34.9v121.7h46.9v29.5h-81.8V94.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "101.9,153.2 101.9,245.7 136.8,245.7 136.8,182.7 185.7,182.7 185.7,153.2 136.8,153.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "136.8,124 185.7,124 185.7,94.5 101.9,94.5 101.9,124  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.6,
    y: 153.2,
    width: 34.9,
    height: 92.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.6,
    y: 94.5,
    width: 34.9,
    height: 29.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "521.4,124 572,124 572,94.5 486.5,94.5 486.5,124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "521.4,182.7 569.5,182.7 569.5,153.2 521.4,153.2 486.5,153.2 486.5,245.7 572,245.7 572,216.2 521.4,216.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "435.3,124 468.2,124 468.2,94.5 367.5,94.5 367.5,124 400.4,124  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.4,
    y: 153.2,
    width: 34.9,
    height: 92.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo06);
export default __webpack_public_path__ + "static/media/Logo-06.1e87e81799e13c68108a161beac2d6b0.svg";
export { ForwardRef as ReactComponent };